import React from "react";

export default function ModalComponent({
  children,
  heading,
  primaryButton,
  primaryButtonName,
  secondaryButton,
  secondaryButtonName,
  rightBottonButton,
  centerBottonButton,
}) {
  return (
    <div className="modal fade" id="sendModal">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{heading}</h5>
            <button type="button" className="close" data-dismiss="modal">
              <span>×</span>
            </button>
          </div>

          <div className="modal-body">
            <form className="comment-form">
              <div className="row">{children}</div>
              {centerBottonButton && (
                <div className="col-lg-12" style={{ marginTop: 10 }}>
                  <div className="form-group mb-0 text-center">
                    <button
                      style={{ marginRight: 10 }}
                      data-dismiss="modal"
                      type="submit"
                      id="tests"
                      defaultValue="Post Comment"
                      className="submit btn btn-primary"
                      name="submit"
                      onClick={primaryButton}
                    >
                      {primaryButtonName}
                    </button>
                    <button
                      style={{ marginRight: 10 }}
                      data-dismiss="modal"
                      type="submit"
                      id="tests"
                      className="submit btn btn-primary"
                      name="submit"
                      onClick={secondaryButton}
                    >
                      {secondaryButtonName}
                    </button>
                  </div>
                </div>
              )}
              {rightBottonButton && (
                <div className="modal-footer">
                  <button
                    data-dismiss="modal"
                    type="submit"
                    id="tests"
                    defaultValue="Post Comment"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={primaryButton}
                  >
                    {primaryButtonName}
                  </button>
                  <button
                    data-dismiss="modal"
                    type="submit"
                    id="tests"
                    className="submit btn btn-primary"
                    name="submit"
                    onClick={secondaryButton}
                  >
                    {secondaryButtonName}
                  </button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
